import { toast } from "sonner";
import request from "../../../helpers/request";

export const getAlertasUsuariosEncaminhados = async (
  idLoja,
  idRegional,
  idCliente,
) => {
  const url = `${process.env.REACT_APP_API}/Alerta/GetEncaminhados?idCliente=${idCliente}`;
  const result = await request({
    url,
    method: "GET",
  });

  console.log("getAlertasUsuariosEncaminhados", result);
  return result.data;
};
